<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="text-h6">Usuarios</span>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="openDialog('add')">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        item-value="id"
        dense
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            class="mx-4 small-input"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="openDialog('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <!--v-btn icon color="red" @click="deleteUser(item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn-->
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo para agregar/editar -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="user.name"
              label="Nombre"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="user.email"
              label="Correo Electrónico"
              type="email"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="user.password"
              label="Contraseña"
              type="password"
              outlined
              dense
              required
            ></v-text-field>
            <v-select
              :items="roles"
              label="Rol"
              outlined
              v-model="user.rol"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveUser">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
  
  <script>
import axios from "@/plugins/axios.js";
export default {
  data() {
    return {
      search: "",
      dialog: false,
      dialogTitle: "",
      headers: [
        { text: "Nombre", value: "name" },
        { text: "Correo", value: "email" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      users: [], // Aquí se cargan los datos de usuarios desde la API
      user: {
        id: null,
        name: "",
        rol: 0,
        email: "",
        password: "",
      },
      action: "", // 'add' o 'edit'
      overlay: false,
      roles:[]
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      this.overlay = true;
      axios
        .get("/admin/getUsers")
        .then((response) => {
          this.users = [...response.data];
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    openDialog(action, user = null) {
      this.action = action;
      this.clearForm();
      if(this.action === 'edit'){
        this.user = {
          id: user.id,
          name: user.name,
          rol: user.roles.length ? user.roles[0].id : null,
          email: user.email,
          password: user.password,
        };
      }
      this.dialogTitle =
        action === "add" ? "Agregar Usuario" : "Editar Usuario";
      //this.user = user ? { ...user } : { id: null, name: "", email: "" };
      this.dialog = true;
      this.overlay = true;
      axios
        .get("/admin/getRoles")
        .then((response) => {
          const rolesOptions = response.data.map((item) => ({
            value: item.id,
            text: item.name,
          }));
          rolesOptions.unshift({
            value: 0,
            text: "Seleccione un Rol...",
          });
          this.roles = rolesOptions;
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
          this.msjModal = "Error! " + err;
          this.$refs["msj-modal"].show();
        });
    },
    saveUser() {
      if (this.action === "add") {
        this.createUser();
      } else {
        this.updateUser();
      }
      this.dialog = false;
    },
    validateFields() {
      return (
        this.user.name && this.user.email && this.user.password && this.user.rol //&& this.user.area
      );
    },
    createUser() {
      if (!this.validateFields()) {
        this.msjModal = "Hay campos vacíos o sin seleccionar!";
        this.$refs["msj-modal"].show();
        return;
      }

      this.overlay = true;
      axios
        .post("/register", {
          // Aquí debes enviar los datos del formulario
          name: this.user.name,
          role: this.user.rol,
          email: this.user.email,
          password: this.user.password,
        })
        .then((response) => {
          this.getUsers();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          //console.log(err.response.data.error);
          this.overlay = false;
          this.msjModal = err.response.data.error;
          this.$refs["msj-modal"].show();
        });
    },
    updateUser() {
      this.overlay = true;
      axios
        .post("/admin/update", {
          // Aquí debes enviar los datos del formulario
          id: this.user.id,
          name: this.user.name,
          role: this.user.rol,
          email: this.user.email,
          password: this.user.password,
        })
        .then((response) => {
          this.getUsers();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    deleteUser(id) {
      // Simulación de eliminación
      this.users = this.users.filter((u) => u.id !== id);
    },
    clearForm() {
      this.user = {
        id: null,
        name: "",
        rol: 0,
        email: "",
        password: "",
      };
      this.isEdit = false;
    },
  },
};
</script>

<style scoped>
/* Estilo para reducir la altura del input */
.small-input .v-input__control {
  height: 30px !important; /* Ajusta la altura */
  font-size: 9pt; /* Ajusta el tamaño del texto */
  padding: 4px 8px !important; /* Reduce el padding interno */
}
.small-input .v-label {
  font-size: 0.75rem; /* Reduce el tamaño de la etiqueta */
  top: -6px; /* Ajusta la posición de la etiqueta */
}
</style>
  